import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  DatePicker,
  Select,
  Checkbox,
} from "antd";
import TextArea from "antd/es/input/TextArea";
// import { FaMapLocationDot } from "react-icons/fa6";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { useState } from "react";
import { ImageUrl } from "../../config/helper";
import { Post } from "../../config/api/post";
import { FEEDBACK } from "../../config/constants/api";
import swal from "sweetalert";
import { UserOutlined } from "@ant-design/icons";
import { IoLocationSharp, IoShieldOutline } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { AiOutlineCar } from "react-icons/ai";

const onChange = (date, dateString) => {
  console.log(date, dateString);
};

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const ContactComponent2 = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const { firstName, lastName, email, message, subject } = values;
    let body = {
      firstName,
      lastName,
      email,
      message,
      subject,
      type: "USER",
    };
    Post(FEEDBACK.addFeedback, body)
      .then((response) => {
        if (response?.status) {
          setLoading(false);
          form.resetFields();
          swal("System Alert", response?.message, "success");
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        setLoading(false);
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };

  return (
    <>
      <Row justify="center" className="py-16 max-sm:py-8">
        <Col xl={16} xs={22} className="bg-[#323131] p-12 max-sm:p-6">
          <Row justify="center">
            <Col lg={24} xs={24} className="bg-[#323131] lg:py-6 md:px-12">
              <h4 className="font-goldman text-white text-center text-3xl mb-4">
                Booking Form For Payments
              </h4>
              <Form
                form={form}
                name="normal_login"
                onFinish={onFinish}
                layout="vertical"
              >
                <Row justify="center" gutter={[16, 16]}>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="pickUpDate"
                      rules={[
                        {
                          required: true,
                          message: "Please input Pick Up Date!",
                        },
                      ]}
                    >
                      <DatePicker
                        placeholder="Pick Up Date"
                        onChange={onChange}
                        className="h-12 text-sm font-euclid bg-gray-100 w-full"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="duration"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Duration!",
                        },
                      ]}
                    >
                      <Select
                        defaultValue="Duration"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        onChange={handleChange}
                        options={[
                          {
                            value: "04 Hours",
                            label: "04 Hours",
                          },
                          {
                            value: "06 Hours",
                            label: "06 Hours",
                          },
                          {
                            value: "08 Hours",
                            label: "08 Hours",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="pickUpLocation"
                      rules={[
                        {
                          required: true,
                          message: "Please input Pick Up Location!",
                        },
                      ]}
                    >
                      <Input
                        prefix={<IoLocationSharp />}
                        placeholder="Pick Up Location"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="dropOffLocation"
                      rules={[
                        {
                          required: true,
                          message: "Please input Drop Off Location!",
                        },
                      ]}
                    >
                      <Input
                        prefix={<IoLocationSharp />}
                        placeholder="Drop Off Location"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="firstName"
                      rules={[
                        {
                          required: true,
                          message: "Please input your first name!",
                        },
                      ]}
                    >
                      <Input
                        prefix={<UserOutlined />}
                        placeholder="First Name"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="lastName"
                      rules={[
                        {
                          required: true,
                          message: "Please input your last name!",
                        },
                      ]}
                    >
                      <Input
                        prefix={<UserOutlined />}
                        placeholder="Last Name"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please input your email address!",
                        },
                      ]}
                    >
                      <Input
                        prefix={<MdEmail />}
                        placeholder="Email Address"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                        type="email"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="phone"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Phone Number!",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="Phone Number"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="vehicleCategory"
                      rules={[
                        {
                          required: true,
                          message: "Please input Vehicle Category!",
                        },
                      ]}
                    >
                      <Select
                        defaultValue="Vehicle Category"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        onChange={handleChange}
                        options={[
                          {
                            value: "Black Luxury",
                            label: "Black Luxury",
                          },
                          {
                            value: "Ultra Luxury",
                            label: "Ultra Luxury",
                          },
                          {
                            value: "SUV Luxury",
                            label: "SUV Luxury",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={12} xs={24}>
                    <Form.Item
                      name="numberOfPassenger"
                      rules={[
                        {
                          required: true,
                          message: "Please input Number Of Passenger!",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="Number Of Passenger"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={24} sm={24} xs={24}>
                    <Form.Item
                      name="services"
                      rules={[
                        {
                          required: true,
                          message: "Please select services!",
                        },
                      ]}
                    >
                      <Select
                        defaultValue="Services"
                        className="h-12 text-sm font-euclid bg-gray-100"
                        onChange={handleChange}
                        options={[
                          {
                            value: "Distance",
                            label: "Distance",
                          },
                          {
                            value: "Half Day",
                            label: "Half Day",
                          },
                          {
                            value: "Full Day",
                            label: "Full Day",
                          },
                          {
                            value: "Sprinters",
                            label: "Sprinters",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={24} sm={24} xs={24}>
                    <Form.Item
                      name="message"
                      rules={[
                        {
                          required: true,
                          message: "Please input your message!",
                        },
                      ]}
                    >
                      <TextArea
                        placeholder="Special Notes"
                        rows={6}
                        className="text-lg font-euclid bg-gray-100"
                        autoComplete={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={24} sm={24} xs={24}>
                    <Form.Item
                      name="terms"
                      valuePropName="checked"
                      className="flex items-center"
                    >
                      <Checkbox>
                        <p className="text-sm text-white font-euclid max-xl:text-xs">
                          Agree to Terms and Conditions
                        </p>
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col md={24} sm={24} xs={24} className="text-center">
                    <Form.Item>
                      <Button htmlType="submit" className="web-btn px-10 h-11">
                        {loading ? "LOADING..." : "Submit"}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>

                {/* <Row gutter={[16, 8]}>
                <Col md={8}>
                  <Form.Item>
                    <Button htmlType="submit" className="web-btn px-10 h-11">
                      {loading ? "LOADING..." : "Submit"}
                    </Button>
                  </Form.Item>
                </Col>
              </Row> */}
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>

      <section className="py-5 home-modals-box">
        <h3 className="font-goldman text-white text-[40px] leading-[75px] text-center res-40">
          Make Your Trip With Us
        </h3>
        <Row justify={"center"}>
          <Col lg={18}>
            <Row className="">
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    <IoShieldOutline />
                  </div>
                  <h4 className="font-goldman text-white">Safety First</h4>
                  <p>
                    We follow the highest security standards to make your
                    journey comfortable and secure.
                  </p>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    {/* <MdEmail /> */}
                    <img
                      src={ImageUrl("ticket-car.png")}
                      alt="vector"
                      className=""
                    />
                  </div>
                  <h4 className="font-goldman text-white">
                    Prices With No Surprises
                  </h4>
                  <p>
                    Our upfront quotes ensure there are no hidden or unexpected
                    charges, so you enjoy your trip carefree.
                  </p>
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={23} xs={23}>
                <div className="adress-box">
                  <div className="adres-icon-box">
                    <AiOutlineCar />
                  </div>
                  <h4 className="font-goldman text-white">
                    Private Travel Solutions
                  </h4>
                  <p>
                    With us, you get to travel your way to any meeting, special
                    event, or even to a different city.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="pb-5 home-modals-box">
        <Row justify={"center"}>
          <Col lg={18} md={20} xs={23}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.785086098263!2d-74.29970392344875!3d40.98618662078408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3034f6c98ea0f%3A0xea256f99c5b97d0a!2sLuxury%20Car%20Chauffeur%20Service!5e0!3m2!1sen!2s!4v1726603877275!5m2!1sen!2s"
              width="100%"
              height="500px"
              style={{ border: "0", borderRadius: "24px" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default ContactComponent2;
